<template>
    <!-- overlay-class="pop-container"  teleport="body"-->
    <van-overlay
        :show="show"
        @click="$emit('update:show',false)"
        :class="messageType==2 ? 'testDriver-container' : ''"
        :zIndex="10"
    >
        <div class="pop-container message-model-container" @click.stop>
            
            <div class="pop-content">
                <div class="pop-title" v-if="messageType==1"></div>
                <div class="pop-content-in">
                    <!-- <div class="car-name">{{carName}}</div> -->
                    <div class="car-name" v-if="messageType==1">{{modelName}}</div>
                    <div class="car-name title" v-else>预约试驾</div>
                    <div class="form-item form-name">
                        <input type="text" id="name" v-model="name" placeholder="姓名" autocomplete="off">
                    </div>
                    <div class="form-item form-mobile">
                        <input type="tel" autocomplete="off" maxlength="11" id="mobile" v-model.lazy.trim.number="mobile" placeholder="手机号码">
                    </div>
                    <div class="form-item form-city">
                        <input type="text" autocomplete="off"  id="city" v-model.lazy.trim="city" placeholder="提车城市" disabled>
                    </div>
                    <!--提交按钮-->
                    <button class="submit-btn" @click.self="submitFormFn">提交</button>

                    <div class="privacy-tip flex flex-center">
                        <!-- <label class="statement-radio-box flex flex-center" bindtap="toggleStatementRadioFn">
                            <radio checked="{{isAgreenStatement}}" class="statement-radio">我同意</radio>
                            <text class="radio-text"></text>
                        </label> -->
                        <!-- :value="isAgreenStatement" @change="toggleStatementRadioFn" -->
                        <!-- <input type="radio" id="statement-radio" :value="isAgreenStatement" v-model="agreenStatement" /> -->
                        <input type="checkbox" id="statement-radio" v-model="isAgreenStatement" />
                        <label for="statement-radio">我同意</label> <a href="javascript:;" class="statement-btn" @click="togglePrivacyPopover(true)">《个人信息保护声明》</a>
                    </div>
                </div>
            </div>
            <div class="pop-close" @click.self="$emit('update:show',false)"></div>
        </div>
    </van-overlay>
    <!-- :color="privacyColor" -->
     <Privacy v-model:show="showPrivacyPopover" @togglePrivacyPopover="togglePrivacyPopover"/>
</template>

<script>
import Privacy from '@/components/common/Privacy.vue'
import { addClue, joinTestDriver } from '@/service/activity/brandWeek';
// import BrandWeekStore from '@/store/modules/brandWeek';
export default {
    name: "MessageModel",
    components: {
        Privacy
    },
    props: {
        show: Boolean,
        goodsId: [String, Number],
        carName: String,
        messageType: [String, Number],
        messageId: [String, Number],
        modelName: String
    },
    data(){
        return {
            showPrivacyPopover: false,
            isAgreenStatement: true,
            agreenStatement: true,
            name: '',
            mobile: '',
            city: '北京市'
        }
    },
    emits: ['update:show', 'addClueSuccess'],
    methods:{
        togglePrivacyPopover(value){
            this.showPrivacyPopover = value;
        },
        submitFormFn(){
            const that = this;
            this.$toast.loading({
                message: '提交中',
                forbidClick: true
            })
            const name = this.name.trim(),
                mobile = this.mobile.trim();
            if (!name) {
                that.$toast("请输入姓名！");
                setTimeout(() => {
                    that.$toast.clear();
                }, 1000);
                return false;
            }
            if(!mobile){
                that.$toast("请输入手机号！");
                 setTimeout(() => {
                    that.$toast.clear();
                }, 1000);
                return false;
            }
            if(!(/^1[3,4,5,6,7,8,9]\d{9}$/).test(mobile)){
                that.$toast("请正确输入手机号！");
                setTimeout(() => {
                    that.$toast.clear();
                }, 1000);
                return false;
            }
            if(!that.isAgreenStatement){
                that.$toast("请勾选个人信息保护声明！");
                setTimeout(() => {
                    that.$toast.clear();
                }, 1000);
                return false;
            }
            if (that.messageType==2) {
                //留资
                joinTestDriver({
                    name,
                    mobile,
                    ext_2: '北京',
                    activity_id: that.messageId,
                    platform:"h5"
                }).then(res=>{
                    that.$toast.clear();
                    if (res.code == 0) {
                        that.$emit('update:show',false)
                        that.$toast({
                            message: '报名成功，工作人员将很快与您取得联系',
                            forbidClick: true
                        })
                    } else {
                        that.$toast(res.message)
                    }
                }).catch(error=>{
                    that.$toast.clear();
                    console.log(error)
                    that.$toast('提交失败，请重试')
                })
            } else {
                // eslint-disable-next-line
                _hmt.push(['_trackEvent', '留资弹窗', '留资按钮']);
                that.$session.loginScope(that.$parent.$refs.login,function(is_login, data){
                    return new Promise(resolve => {
                        //本地校验已登录
                        if (is_login) {
                            if (data) {
                                that.$parent.getGoodsInfo();
                            }
                            //秒杀
                            addClue({
                                name,
                                mobile,
                                goods_id: that.goodsId,
                                type: 1
                            }).then(res => {
                                    if (typeof res == 'string') {
                                        res = JSON.parse(res);
                                    }
                                    if (res.code==200) {
                                        that.$toast.clear();
                                        that.$toast({
                                            message: '提交成功！',
                                            forbidClick: true
                                        })
                                        setTimeout(function(){
                                            that.$emit('addClueSuccess', that.goodsId, res.data.has_wxinfo)
                                        }, 1500)
                                    } else if (res.code==501) {
                                        that.$toast.clear();
                                        that.$session.update(false);
                                        resolve(false);
                                    } else {
                                        that.$toast.clear();
                                        that.$toast(res.message || '请求失败');
                                    }
                            }).catch( err =>{
                                that.$toast.clear();
                                console.log('留资catch错误', err)
                            })
                        }
                    })
                })
            }
        }
    }
}
</script>

<style scoped lang="less">
.message-model-container{
    max-height: 90%;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    background-color: transparent;
    transition: transform 0.3s;
    -webkit-overflow-scrolling: touch;
    .pop-title{
        width: 612px;
        height: 239px;
        background: url(../../assets/images/brandWeek/message_model_tit.png) no-repeat;
        background-size: 100%;
        position: absolute;
        z-index: 2;
        top: -112px;
        left: 53px;
    }
    .pop-content{
        position: relative;
        width: 710px;
        border-radius: 20px;
        padding: 12px;
        background: linear-gradient(#fbd98e 40%,#d674ff);
        // overflow: hidden;
        .pop-content-in{
            padding: 12px 48px 54px 54px;
            border-radius: 20px;
            background-color: #fff;
        }
        .car-name{
            margin-top: 63px;
            margin-bottom: 30px;
            line-height: 1.65;
            font-size: 32px;
            color: #ff4381;
            text-align: center;
            &.title{
                font-size: 44px;
                font-weight: bold;
                margin-top: 40px;
            }
        }
        .privacy-tip{
            font-size: 24px;
            color: #bebebe;
            #statement-radio{
                margin-right: 22px;
            }
            .statement-btn{
                color: #83a5fb;
            }
        }
        .form-item{
            width: 100%;
            height: 93px;
            border-radius: 46px;
            /* background: #f3f3f3; */
            margin-bottom: 27px;
            font-size: 28px;
            overflow: hidden;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &:last-child{
                margin-bottom: 0;
            }
            input{
                width: 100%;
                height: 100%;
                border: none;
                background: #f3f3f3;
                color: #8b64c0;
                padding-left: 108px;
                &::-webkit-input-placeholder { 
                    color: #8b64c0;
                }
                &::-moz-input-placeholder { 
                    color: #8b64c0;
                }
                &::-ms-input-placeholder { 
                    color: #8b64c0;
                }
            }
            &.form-name input{
                background: #f3f3f3 url(../../assets/images/brandWeek/icon-user.png) no-repeat left center;
                background-size: 29px 31px;
                background-position-x: 46px;
            }
            &.form-mobile input{
                background: #f3f3f3 url(../../assets/images/brandWeek/icon-phone.png) no-repeat left center;
                background-size: 24px 37px;
                background-position-x: 51px;
            }
            &.form-city input{
                background: #f3f3f3 url(../../assets/images/brandWeek/location_icon.png) no-repeat left center;
                background-size: 30px;
                background-position-x: 43px;
            }
        }
        .submit-btn{
            display: block;
            width: 585px;
            height: 93px;
            line-height: 94px;
            font-size: 36px;
            margin: 29px auto 37px auto;
            color: #fff;
            text-align: center;
            background: url(../../assets/images/brandWeek/login_btn.png) no-repeat;
            background-size: 100%;
            outline: none;
            border: none;
        }
    }
    .pop-close{
        width: 72px;
        height: 72px;
        background: url(../../assets/images/brandWeek/login_close.png) no-repeat;
        background-size: 100%;
        position: relative;
        // bottom: -90px;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 86px;
    }
    &.testDriver-container{
        .pop-content{
            margin-top: 0;
            .car-name{
                font-size: 48px;
                line-height: 1.6;
                text-align: center;
                margin: 50px 0 50px 0;
            }
        }
    }
}
</style>